import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrow360 = () => {
  return (
    <g>
      <path d="m6.217 1.147.084.073 2.23 2.23a.75.75 0 0 1 .072.977l-.073.084-2.229 2.23a.75.75 0 0 1-1.133-.977l.073-.085.948-.949h-.306A4.383 4.383 0 0 0 1.5 9.115a4.384 4.384 0 0 0 4.17 4.38l.213.004h4.243A4.375 4.375 0 0 0 14.5 9.124a4.387 4.387 0 0 0-4.004-4.371.75.75 0 0 1 .128-1.495A5.887 5.887 0 0 1 16 9.124a5.875 5.875 0 0 1-5.654 5.872l-.22.004H5.883A5.884 5.884 0 0 1 0 9.115a5.884 5.884 0 0 1 5.662-5.881l.22-.004.306-.001-.947-.948a.75.75 0 0 1-.073-.977l.073-.084a.75.75 0 0 1 .976-.073z" />
    </g>
  );
};

export default withIcon(IconArrow360);
